module.exports = __webpack_public_path__ + "img/project.46f3e275.svg";